export const GET_ADMIN_LOGIN_HISTORY_LIST = "GET_ADMIN_LOGIN_HISTORY_LIST";